import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  NotificationMessage,
  NotificationsQueue,
} from '@/components/Notifications';
import { Endpoint, QueryKey } from '@/constants';
import { postData } from '@/utils/postData';

export const useUpdateQuantity = () => {
  const queryClient = useQueryClient();

  const { isPending: isRemovePending, mutate: removeItem } = useMutation({
    mutationFn: postData(Endpoint.RemoveItem),
    onError: error => {
      console.error(`Error removing item from cart: ${error}`);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.CustomerStatus] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.GetCart] });

      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={!data.isSuccess}>
              {data.messages[0]}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );
    },
  });

  const { isPending: isUpdatePending, mutate: updateQuantity } = useMutation({
    mutationFn: postData(Endpoint.UpdateItem),
    onError: error => {
      console.error(`Error updating item quantity: ${error}`);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.CustomerStatus] });
      queryClient.invalidateQueries({ queryKey: [QueryKey.GetCart] });

      NotificationsQueue.add(
        {
          notification: (
            <NotificationMessage $isError={!data.isSuccess}>
              {data.messages[0]}
            </NotificationMessage>
          ),
        },
        { timeout: 5000 },
      );
    },
  });

  return {
    isPending: isRemovePending || isUpdatePending,
    removeItem,
    updateQuantity,
  };
};
